import React, { useState, useEffect, useRef } from "react";
import SimpleBarReact from "simplebar-react";
import _ from "lodash";
import SortableList, { SortableItem } from "react-easy-sort";
import moment from "moment";
import './MasterSchedulePrint.css';
import { COLORS } from '../../../../../Util/helper';
import { withRouter } from "react-router-dom";

function MasterSchedulePrint(props) {
  const { selected } = props?.data;
  const teamName = (id) => {
    let name = '';
    if (id && props?.data.teams) {
      const findTeam = props?.data.teams.find(x => +x.id === +id);
      if (findTeam) {
        name = `${findTeam.name}`;
      }
    }
    return name;
  }
  const leagueName = (id) => {
    let name = '';
    if (id && props?.data.leagues) {
      const findLeague = props?.data.leagues.find(x => +x.id === +id);
      if (findLeague) {
        name = `${findLeague.name}`;
      }
    }
    return name;
  }
  const colorCode = (id) => {
    let color = '';
    if (id && props?.data.leagues) {
      color = props?.data.leagues.find(x => +x.id === +id) ? props?.data.leagues.find(x => +x.id === +id).color : '';
    }
    return color;
  }
  return <>
    <div class="schedule-table">
      <table class="table-container">
        <thead class="table-row table-heading">
          <tr>
            <th class="table-item empty dt-cell">&nbsp;</th>
            {
              props?.data?.fields &&
              props?.data.fields.length > 0 &&
              props?.data.fields.map((field, idx) => (
                <th class={`table-item ${idx + 1 === props?.data.fields.length ? 'last' : ''}`} key={idx}><p>{field?.title}</p></th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            props?.data?.matches &&
            props?.data.matches.length > 0 &&
            props?.data.matches.map((match, idx) => (
              <tr class="table-row">
                <td class="table-item dt-cell">
                  <p>{match.date}</p>
                  <p>{match.time}</p>
                </td>
                {
                  match.schedule &&
                  match.schedule.length &&
                  match.schedule.map((sc, i) => (
                    <td class={`table-item ${i + 1 === props?.data.fields.length ? 'last' : ''}`}>
                      {
                        ((sc.team1_id > 0 &&
                        sc.team2_id > 0) || ['date', 'round'].includes(selected) && sc.id > 0) &&
                        <>
                          <p>{sc.team1_id ? <>{teamName(sc.team1_id)} ({sc.team1_score ? sc.team1_score : 0})</>: 'TBD' }</p>
                          <p>VS</p>
                          <p>{sc.team2_id ? <>{teamName(sc.team2_id)} ({sc.team2_score ? sc.team2_score : 0})</>: 'TBD'}</p>
                          <div class="btn-clr-bar" title={leagueName(sc?.league_id)} style={{ background: colorCode(sc?.league_id) }}></div>
                        </>
                      }
                      {
                        !sc.team1_id &&
                        !sc.team2_id &&
                        <span></span>
                      }
                      {
                        sc.leagueIds &&
                        !sc.team1_id &&
                        !sc.team2_id &&
                        <>
                          {
                            sc.leagueIds.map((leagueid, lk) => {
                              if (props?.data.leagues.find(x => x.id === leagueid)) {
                                return <div class="color-dot" title={leagueName(leagueid)} style={{ background: colorCode(leagueid) }}></div>
                              } else {
                                return null;
                              }

                            })
                          }
                        </>
                      }
                    </td>
                  ))
                }

              </tr>
            ))
          }
        </tbody>
        <tfoot>
          {
            <tr class="table-row">
              <td></td>
              <td class="table-btm-box" colSpan={props?.data.fields.length}>
                {props?.data &&
                  props?.data.leagues &&
                  props?.data.leagues.length &&
                  props?.data.leagues.map((league, i) => (
                    <div class="table-btm-item">
                      <div class="color-dot" style={{ background: colorCode(league?.id) }}></div>
                      <p>{leagueName(league.id)}</p>
                    </div>
                  ))}
              </td>
            </tr>
          }
        </tfoot>
      </table>

    </div>
  </>
}
export default withRouter(MasterSchedulePrint);
